// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.6.1
//   protoc               unknown
// source: structs/structs/grid.proto

/* eslint-disable */
import { BinaryReader, BinaryWriter } from "@bufbuild/protobuf/wire";

export const protobufPackage = "structs.structs";

export interface GridRecord {
  attributeId: string;
  value: string;
}

export interface GridAttributes {
  ore: string;
  fuel: string;
  capacity: string;
  load: string;
  structsLoad: string;
  power: string;
  connectionCapacity: string;
  connectionCount: string;
  allocationPointerStart: string;
  allocationPointerEnd: string;
  proxyNonce: string;
  lastAction: string;
  nonce: string;
  ready: string;
  checkpointBlock: string;
}

function createBaseGridRecord(): GridRecord {
  return { attributeId: "", value: "0" };
}

export const GridRecord: MessageFns<GridRecord> = {
  encode(message: GridRecord, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.attributeId !== "") {
      writer.uint32(10).string(message.attributeId);
    }
    if (message.value !== "0") {
      writer.uint32(16).uint64(message.value);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GridRecord {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGridRecord();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.attributeId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.value = reader.uint64().toString();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GridRecord {
    return {
      attributeId: isSet(object.attributeId) ? globalThis.String(object.attributeId) : "",
      value: isSet(object.value) ? globalThis.String(object.value) : "0",
    };
  },

  toJSON(message: GridRecord): unknown {
    const obj: any = {};
    if (message.attributeId !== "") {
      obj.attributeId = message.attributeId;
    }
    if (message.value !== "0") {
      obj.value = message.value;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GridRecord>, I>>(base?: I): GridRecord {
    return GridRecord.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GridRecord>, I>>(object: I): GridRecord {
    const message = createBaseGridRecord();
    message.attributeId = object.attributeId ?? "";
    message.value = object.value ?? "0";
    return message;
  },
};

function createBaseGridAttributes(): GridAttributes {
  return {
    ore: "0",
    fuel: "0",
    capacity: "0",
    load: "0",
    structsLoad: "0",
    power: "0",
    connectionCapacity: "0",
    connectionCount: "0",
    allocationPointerStart: "0",
    allocationPointerEnd: "0",
    proxyNonce: "0",
    lastAction: "0",
    nonce: "0",
    ready: "0",
    checkpointBlock: "0",
  };
}

export const GridAttributes: MessageFns<GridAttributes> = {
  encode(message: GridAttributes, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.ore !== "0") {
      writer.uint32(8).uint64(message.ore);
    }
    if (message.fuel !== "0") {
      writer.uint32(16).uint64(message.fuel);
    }
    if (message.capacity !== "0") {
      writer.uint32(24).uint64(message.capacity);
    }
    if (message.load !== "0") {
      writer.uint32(32).uint64(message.load);
    }
    if (message.structsLoad !== "0") {
      writer.uint32(40).uint64(message.structsLoad);
    }
    if (message.power !== "0") {
      writer.uint32(48).uint64(message.power);
    }
    if (message.connectionCapacity !== "0") {
      writer.uint32(56).uint64(message.connectionCapacity);
    }
    if (message.connectionCount !== "0") {
      writer.uint32(64).uint64(message.connectionCount);
    }
    if (message.allocationPointerStart !== "0") {
      writer.uint32(72).uint64(message.allocationPointerStart);
    }
    if (message.allocationPointerEnd !== "0") {
      writer.uint32(80).uint64(message.allocationPointerEnd);
    }
    if (message.proxyNonce !== "0") {
      writer.uint32(88).uint64(message.proxyNonce);
    }
    if (message.lastAction !== "0") {
      writer.uint32(96).uint64(message.lastAction);
    }
    if (message.nonce !== "0") {
      writer.uint32(104).uint64(message.nonce);
    }
    if (message.ready !== "0") {
      writer.uint32(112).uint64(message.ready);
    }
    if (message.checkpointBlock !== "0") {
      writer.uint32(120).uint64(message.checkpointBlock);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GridAttributes {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGridAttributes();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.ore = reader.uint64().toString();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.fuel = reader.uint64().toString();
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.capacity = reader.uint64().toString();
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.load = reader.uint64().toString();
          continue;
        }
        case 5: {
          if (tag !== 40) {
            break;
          }

          message.structsLoad = reader.uint64().toString();
          continue;
        }
        case 6: {
          if (tag !== 48) {
            break;
          }

          message.power = reader.uint64().toString();
          continue;
        }
        case 7: {
          if (tag !== 56) {
            break;
          }

          message.connectionCapacity = reader.uint64().toString();
          continue;
        }
        case 8: {
          if (tag !== 64) {
            break;
          }

          message.connectionCount = reader.uint64().toString();
          continue;
        }
        case 9: {
          if (tag !== 72) {
            break;
          }

          message.allocationPointerStart = reader.uint64().toString();
          continue;
        }
        case 10: {
          if (tag !== 80) {
            break;
          }

          message.allocationPointerEnd = reader.uint64().toString();
          continue;
        }
        case 11: {
          if (tag !== 88) {
            break;
          }

          message.proxyNonce = reader.uint64().toString();
          continue;
        }
        case 12: {
          if (tag !== 96) {
            break;
          }

          message.lastAction = reader.uint64().toString();
          continue;
        }
        case 13: {
          if (tag !== 104) {
            break;
          }

          message.nonce = reader.uint64().toString();
          continue;
        }
        case 14: {
          if (tag !== 112) {
            break;
          }

          message.ready = reader.uint64().toString();
          continue;
        }
        case 15: {
          if (tag !== 120) {
            break;
          }

          message.checkpointBlock = reader.uint64().toString();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GridAttributes {
    return {
      ore: isSet(object.ore) ? globalThis.String(object.ore) : "0",
      fuel: isSet(object.fuel) ? globalThis.String(object.fuel) : "0",
      capacity: isSet(object.capacity) ? globalThis.String(object.capacity) : "0",
      load: isSet(object.load) ? globalThis.String(object.load) : "0",
      structsLoad: isSet(object.structsLoad) ? globalThis.String(object.structsLoad) : "0",
      power: isSet(object.power) ? globalThis.String(object.power) : "0",
      connectionCapacity: isSet(object.connectionCapacity) ? globalThis.String(object.connectionCapacity) : "0",
      connectionCount: isSet(object.connectionCount) ? globalThis.String(object.connectionCount) : "0",
      allocationPointerStart: isSet(object.allocationPointerStart)
        ? globalThis.String(object.allocationPointerStart)
        : "0",
      allocationPointerEnd: isSet(object.allocationPointerEnd) ? globalThis.String(object.allocationPointerEnd) : "0",
      proxyNonce: isSet(object.proxyNonce) ? globalThis.String(object.proxyNonce) : "0",
      lastAction: isSet(object.lastAction) ? globalThis.String(object.lastAction) : "0",
      nonce: isSet(object.nonce) ? globalThis.String(object.nonce) : "0",
      ready: isSet(object.ready) ? globalThis.String(object.ready) : "0",
      checkpointBlock: isSet(object.checkpointBlock) ? globalThis.String(object.checkpointBlock) : "0",
    };
  },

  toJSON(message: GridAttributes): unknown {
    const obj: any = {};
    if (message.ore !== "0") {
      obj.ore = message.ore;
    }
    if (message.fuel !== "0") {
      obj.fuel = message.fuel;
    }
    if (message.capacity !== "0") {
      obj.capacity = message.capacity;
    }
    if (message.load !== "0") {
      obj.load = message.load;
    }
    if (message.structsLoad !== "0") {
      obj.structsLoad = message.structsLoad;
    }
    if (message.power !== "0") {
      obj.power = message.power;
    }
    if (message.connectionCapacity !== "0") {
      obj.connectionCapacity = message.connectionCapacity;
    }
    if (message.connectionCount !== "0") {
      obj.connectionCount = message.connectionCount;
    }
    if (message.allocationPointerStart !== "0") {
      obj.allocationPointerStart = message.allocationPointerStart;
    }
    if (message.allocationPointerEnd !== "0") {
      obj.allocationPointerEnd = message.allocationPointerEnd;
    }
    if (message.proxyNonce !== "0") {
      obj.proxyNonce = message.proxyNonce;
    }
    if (message.lastAction !== "0") {
      obj.lastAction = message.lastAction;
    }
    if (message.nonce !== "0") {
      obj.nonce = message.nonce;
    }
    if (message.ready !== "0") {
      obj.ready = message.ready;
    }
    if (message.checkpointBlock !== "0") {
      obj.checkpointBlock = message.checkpointBlock;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GridAttributes>, I>>(base?: I): GridAttributes {
    return GridAttributes.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GridAttributes>, I>>(object: I): GridAttributes {
    const message = createBaseGridAttributes();
    message.ore = object.ore ?? "0";
    message.fuel = object.fuel ?? "0";
    message.capacity = object.capacity ?? "0";
    message.load = object.load ?? "0";
    message.structsLoad = object.structsLoad ?? "0";
    message.power = object.power ?? "0";
    message.connectionCapacity = object.connectionCapacity ?? "0";
    message.connectionCount = object.connectionCount ?? "0";
    message.allocationPointerStart = object.allocationPointerStart ?? "0";
    message.allocationPointerEnd = object.allocationPointerEnd ?? "0";
    message.proxyNonce = object.proxyNonce ?? "0";
    message.lastAction = object.lastAction ?? "0";
    message.nonce = object.nonce ?? "0";
    message.ready = object.ready ?? "0";
    message.checkpointBlock = object.checkpointBlock ?? "0";
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}

export interface MessageFns<T> {
  encode(message: T, writer?: BinaryWriter): BinaryWriter;
  decode(input: BinaryReader | Uint8Array, length?: number): T;
  fromJSON(object: any): T;
  toJSON(message: T): unknown;
  create<I extends Exact<DeepPartial<T>, I>>(base?: I): T;
  fromPartial<I extends Exact<DeepPartial<T>, I>>(object: I): T;
}
